export default "__VITE_ASSET__CXSXpJw9__"